module.exports = __webpack_public_path__ + "img/vulgar1.adc28a91.jpg";